import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronRight as solidChevronRight,
  faChevronLeft as solidChevronLeft,
  faCheck as solidCheck,
  faCloudDownloadAlt,
  faPen as solidPencil,
  faHeart as solidHeart,
  faQuoteLeft,
  faQuoteRight,
  faEllipsisV,
  faBriefcase,
  faBookOpen,
  faPhone,
  faUserFriends,
  faCoins,
  faChevronDown,
  faPercent,
  faSearch,
  faCheck,
  faArrowLeft,
  faStar,
  faClock,
  faSeedling,
  faEnvelope,
  faCheckCircle,
  faPencilAlt,
  faTimes,
  faDollarSign,
  faFileAlt,
  faPlus,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import {
  faHeart as regularHeart,
  faEnvelopeOpen
} from '@fortawesome/free-regular-svg-icons';

library.add(
  solidChevronRight,
  solidChevronLeft,
  solidCheck,
  solidHeart,
  regularHeart,
  solidPencil,
  faQuoteLeft,
  faQuoteRight,
  faEllipsisV,
  faBriefcase,
  faBookOpen,
  faEnvelopeOpen,
  faPhone,
  faUserFriends,
  faCoins,
  faChevronDown,
  faPercent,
  faSearch,
  faCheck,
  faCloudDownloadAlt,
  faArrowLeft,
  faStar,
  faClock,
  faSeedling,
  faEnvelope,
  faCheckCircle,
  faPencilAlt,
  faTimes,
  faDollarSign,
  faFileAlt,
  faPlus,
  faTrash
);
